<template>
  <h2
    :class="[
      'font-secondary text-3xl py-2',
      'lg:pb-2 lg:border-b lg:border-black lg:border-opacity-35 lg:py-4',
      'lt-lg:(flex justify-between items-center gap-6)',
    ]"
  >
    <slot />
    <Icon name="ChevronRight" class="lg:!hidden" />
  </h2>
</template>

<script setup lang="ts"></script>

<style scoped></style>
